import { render } from "./letter-list.vue?vue&type=template&id=1898389a"
import script from "./letter-list.vue?vue&type=script&lang=js"
export * from "./letter-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__